export default __webpack_public_path__ + "static/media/bg.69279ebe.webp";